<template>
  <div>
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <div class="amc-service-create-page" v-else>
      <!--  credit form component -->
      <AmcServiceForm
        :submitted="submitted"
        :duplicatecode="duplicatecode"
        v-on:onSubmit="onSubmit($event)"
        v-on:FormUpdate="FormUpdate = 1"
        page="create"
      >
        <!-- footer block -->
        <template slot="footer"></template>
      </AmcServiceForm>
    </div>
  </div>
</template>

<script>
import AmcServiceForm from "@/components/Form/Amc/AmcServiceForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
/// back to top for scroll to top of the page
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "getcompositedetails",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    AmcServiceForm,
    RecordNotFound
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.duplicatecode = false;
      this.$store
        .dispatch("amcservice/createList", data)
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          var message;
          if (this.status_code == 200) {
            //  show if invoice successfully created
            // message = "New Product Bundle  has been created successfully!";
            this.$router.push({
              name: "AmcServiceView",
              params: { id: this.updated_id }
            });
          } else {
            //  showing eror message
            this.duplicatecode = true;
            this.submitted = false;
          }
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true
          });
          //  code for notificatin display
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("amcservice/fetchcompositedetails").then(() => {
      store.dispatch("products/fetchProductDetails");
       store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Product",
        stg_name: "pdt_settings_details"
      });
      next();
    });
  },
  updated: function() {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.amcservice.code,
      updated_id: state => state.amcservice.updated_id,
      list: state => state.amcservice.Updatelist,
      status_code: state => state.amcservice.status_code,
      status_message: state => state.amcservice.status_message,
      status_type: state => state.amcservice.status_type
    })
  }
};
</script> 

<style>
</style>
